import { css } from 'styled-components';

const color = css `
  color: ${props => props.$color};
`;

export { color };
//# sourceMappingURL=color.js.map
